import { createStyles } from '../../../styles/helpers'

export default createStyles({
  triggerElement: {
    display: 'flex',
    cursor: 'pointer'
  }
})
